// removed by extract-text-webpack-plugin
module.exports = {"title":"yXDimra6pGZs9TzhSh5Ix","buttonNew":"_1OnASD7oy1ZMCAizJRM3oM","filters":"cz-BPFsssAc5P0L7QsY_k","filter":"_1BUSwiKI8He9_2PcOLdo80","label":"_2g36-zDYt1difc5uGB_Y8t","item":"_1QOiUeGw7AZ6L60niZZ5Ph","searchField":"_116Z2qEZTPL-0CPvr8EDgJ","task":"_1-nePtLVgtu4Nn2gB4Bb0E"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Tasks/style.scss
// module id = 1256
// module chunks = 0